import SubcategoryPage from '@/components/template/SubcategoryPage';

const MarmorniUmivalniki = () => {
  const products = [
    {
      title: "Marmorni Umivalnik Carrara",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni/carrara"
    },
    {
      title: "Marmorni Umivalnik Črni",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni/crni"
    },
    {
      title: "Marmorni Umivalnik Klasičen",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni/klasicen"
    },
    {
      title: "Marmorni Umivalnik Luksuzni",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni/luksuzni"
    },
    {
      title: "Marmorni Umivalnik Modern",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni/modern"
    },
    {
      title: "Marmorni Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni/premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Marmorni Umivalniki"
      description="Raziščite našo izbiro razkošnih marmornih umivalnikov, ki so sinonim za eleganco in brezčasnost. Vsak marmorni umivalnik je unikaten z naravnimi žilami in vzorci, ki poudarjajo luksuz in dodajajo prestižen pridih vaši kopalnici."
      heroImage="https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default MarmorniUmivalniki;